import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getSchools = () => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/school/getall/', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_GETALL_SUCCESS',
                payload: data.schools
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const getSchool = (school) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/school/get/'+ school, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const getSchoolBySelection = (selection) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/school/getBySelection/'+ selection, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const getPaymentMethods = (school) => async (dispatch) => {
    dispatch({type: 'SCHOOL_LOADING'})
    try {
        const { data, status } = await Axios.get('/api/client/school/getpaymentmethods/'+ school, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_GET_PAYMENTMETHODS_SUCCESS',
                payload: data.paymentMethods
            })
        } else {
            dispatch({
                type: 'SCHOOL_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const addPaymentMethod = (paymentMethod) => async (dispatch) => {
    dispatch({type: 'SCHOOL_LOADING'})
    try {
        const { status} = await Axios.put('/api/client/school/addpaymentmethod', paymentMethod, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SCHOOL_ADD_PAYMENTMETHODS_SUCCESS',
                payload: 'success'
            })
        } else {
            dispatch({
                type: 'SCHOOL_ADD_PAYMENTMETHODS_ERROR',
                payload: 'error'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const removePaymentMethod = (userId, paymentMethodId) => async dispatch => {
    dispatch({type: 'SCHOOL_LOADING'})
    try {
        const { status } = await Axios.delete('/api/client/school/removepaymentmethod/' + userId + '/' + paymentMethodId, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_REMOVE_PAYMENTMETHODS_SUCCESS',
                payload: 'successDelete'
            })
        } else {
            dispatch({
                type: 'SCHOOL_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const buyCandidate = (candidate, school) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_LOADING'
    })
    try{
        const { data, status} = await Axios.put('/api/client/school/buycandidate/' + school, {candidate: candidate}, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
    if (status === 200){
        dispatch({
            type: 'SCHOOL_ADDCANDIDATE_SUCCESS',
            payload: data.message
        })
        dispatch({
            type: 'CANDIDATE_ADDSCHOOL_SUCCESS',
            payload: data.candidate
        })
        dispatch({
            type: 'SCHOOL_RESET_RESULT'
        })
    }
    if (status === 264){
        dispatch({
            type: 'SCHOOL_ADDCANDIDATE_ERROR',
            payload: data.message
        })
        dispatch({
            type: 'SCHOOL_RESET_RESULT'
        })
    }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const getSchoolsProvinces = () => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/school/getallwithprovinces/', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_GETPROVINCES_SUCCESS',
                payload: data.schoolsprovinces
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const getMultiSchools = () => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/school/getAllMultiSchools/', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_GETALL_SUCCESS',
                payload: data.schools
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const getReducedSchools = () => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/school/getAllReduced/', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_GETALL_SUCCESS',
                payload: data.schools
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}

export const getReducedSchoolsByMultiSchool = (id) => async (dispatch) => {
    dispatch({
        type: 'SCHOOL_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/school/getReducedByMultiSchool/' + id, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SCHOOL_GETALL_SUCCESS',
                payload: data.schools
            })
        }
    } catch (error) {
        dispatch({
            type: 'SCHOOL_NOT_LOADING'
        })
    }
}